import React, { useRef, useState, useEffect } from 'react';
import ProgressBar from '../ProgressBar/ProgressBar';
import './candidateEmail.css';
import BottomButtons from '../bottom-buttons/BottomButtons';
import history from '../../routes/history';

const CandidateEmail = ({
  CandidateProgressBar,
  CandidateText,
  placeholder,
  nextHandler,
  backHandler,
  inputvalue,
  loading,
  validation,
  clearValidation,
  getInputValues,
  types,
}) => {
  const [isActive, setIsActive] = useState(true);

  const handleClickOutside = (e) => {
    if (inputvalue.current && !inputvalue.current.contains(e.target)) {
      setIsActive(true);
    }
  };

  const handleInputChange = (e) => {
    clearValidation(e);
    setIsActive(false);
  };


  useEffect(() => {
    if (inputvalue.current) {
      inputvalue.current.focus();
      setIsActive(false)
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <div className="profilecompleteion">
      <div>
        {CandidateProgressBar}
        <div className="email-text">
          {CandidateText}
          <div className="email-mandatory">(Mandatory)</div>
        </div>
        <div className={validation ? 'validation-error' : `${isActive ? 'inactive' : 'email-input'}`}>
          <input
            placeholder={placeholder}
            type={types}
            className={`candidate-input ${validation ? '' : isActive ? 'inactive-input' : ''}`}
            ref={inputvalue}
            style={{color: isActive ? '#5e5e5e': "#1E1E1E"}}
            onChange={handleInputChange}
            defaultValue={getInputValues}
            onClick={() => { setIsActive(false) }}
          />
          {validation && (
            <div className="validation-message">{validation}</div>
          )}
          
          <div className="email-button">
            <BottomButtons
              nextHandler={nextHandler}
              backHandler={backHandler}
              nextBtnLoading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateEmail;
